import script from "./AuthSettingsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthSettingsView.vue?vue&type=script&setup=true&lang=js"

import "./AuthSettingsView.vue?vue&type=style&index=0&id=e9ed474e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9ed474e"]])

export default __exports__